import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import './ComingSoon.css';

const ComingSoon = () => {
    const launchDate = new Date('2026-04-30T00:00:00');

    const getTimeLeft = () => {
        const diff = launchDate - new Date();
        if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
        return {
            days: Math.floor(diff / (1000 * 60 * 60 * 24)),
            hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((diff / (1000 * 60)) % 60),
            seconds: Math.floor((diff / 1000) % 60),
        };
    };

    const [timeLeft, setTimeLeft] = useState(getTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => setTimeLeft(getTimeLeft()), 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <main className="coming-soon-page">
            <Header />
            <div className="coming-soon-container">
                <h1 className="coming-soon-title">Çok Yakında</h1>
                <p className="coming-soon-subtitle">
                    Heyecan verici bir şeyler hazırlıyoruz. Takipte kalın!
                </p>
                <div className="countdown">
                    {[
                        { label: 'Gün', value: timeLeft.days },
                        { label: 'Saat', value: timeLeft.hours },
                        { label: 'Dakika', value: timeLeft.minutes },
                        { label: 'Saniye', value: timeLeft.seconds },
                    ].map(({ label, value }) => (
                        <div className="countdown-item" key={label}>
                            <span className="countdown-value">
                                {String(value).padStart(2, '0')}
                            </span>
                            <span className="countdown-label">{label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </main>
    );
};

export default ComingSoon;
